import React, { useState } from "react";

export default function GatewayField({
  label,
  error,
  hint,
  className = "",
  inputClassName = "",
  revealPassword = false,
  ...inputProps
}) {
  const id = inputProps.id || inputProps.name;
  const [passwordVisible, setPasswordVisible] = useState(false);
  const isPasswordField = inputProps.type === "password";
  const resolvedType = revealPassword && isPasswordField && passwordVisible ? "text" : inputProps.type;
  const describedBy = [error ? `${id}-error` : "", hint ? `${id}-hint` : ""]
    .filter(Boolean)
    .join(" ") || undefined;

  return (
    <label
      className={[
        "gatewayField",
        error ? "gatewayField--error" : "",
        revealPassword && isPasswordField ? "gatewayField--password" : "",
        className,
      ].filter(Boolean).join(" ")}
      htmlFor={id}
    >
      {label ? <span className="srOnly">{label}</span> : null}
      <span className="gatewayField__control">
        <input
          {...inputProps}
          type={resolvedType}
          id={id}
          className={inputClassName}
          aria-invalid={Boolean(error)}
          aria-describedby={describedBy}
        />
        {revealPassword && isPasswordField ? (
          <button
            type="button"
            className="gatewayField__passwordToggle"
            aria-label={passwordVisible ? "Hide password" : "Show password"}
            aria-pressed={passwordVisible}
            title={passwordVisible ? "Hide password" : "Show password"}
            onClick={() => setPasswordVisible((visible) => !visible)}
          >
            <span aria-hidden="true">{passwordVisible ? "◉" : "◌"}</span>
          </button>
        ) : null}
      </span>
      {hint ? <small id={`${id}-hint`} className="gatewayField__hint">{hint}</small> : null}
      {error ? <span id={`${id}-error`} className="gatewayError" role="alert">{error}</span> : null}
    </label>
  );
}
